"use client";

import { useEffect } from "react";

// window.open 전역 래핑: features에 width/height가 있는 모든 팝업을
// 현재 브라우저 창 기준 중앙 좌표로 띄운다 (멀티모니터 안전).
// - width/height가 없는 호출(_blank 다운로드 등)은 그대로 둔다.
// - 호출부에서 left/top을 직접 지정했더라도(주 모니터 screen.width 기준 등) 무시하고
//   재계산해, 모든 팝업이 공통으로 활성 모니터 중앙에 뜨도록 통일한다.
export function PopupCenter() {
  useEffect(() => {
    const g = window as Window & { __popupCentered?: boolean };
    if (g.__popupCentered) return;
    g.__popupCentered = true;

    const orig = window.open.bind(window);
    window.open = ((url?: string | URL, target?: string, features?: string): Window | null => {
      let f = features;
      if (typeof f === "string" && /(?:^|,)\s*width=/i.test(f)) {
        const w = parseInt(f.match(/width=(\d+)/i)?.[1] || "0", 10);
        const h = parseInt(f.match(/height=(\d+)/i)?.[1] || "0", 10);
        if (w > 0 && h > 0) {
          const dualLeft = window.screenLeft ?? window.screenX ?? 0;
          const dualTop = window.screenTop ?? window.screenY ?? 0;
          const vw = window.innerWidth || document.documentElement.clientWidth || window.screen.width;
          const vh = window.innerHeight || document.documentElement.clientHeight || window.screen.height;
          const left = Math.round(dualLeft + Math.max(0, (vw - w) / 2));
          const top = Math.round(dualTop + Math.max(0, (vh - h) / 2));
          // 호출부가 직접 넣은 left/top 제거 후 재주입
          f = f.replace(/,?\s*left=-?\d+/gi, "").replace(/,?\s*top=-?\d+/gi, "");
          f = `${f},left=${left},top=${top}`;
        }
      }
      return orig(url as string, target, f);
    }) as typeof window.open;
  }, []);

  return null;
}
